import { take, call, put } from 'redux-saga/effects';
import Auth from '@defi/core-auth';
import {
  REQUEST_FORGOT_PW,
  SET_MFA_CHALLENGE,
} from '../actions/constants';
import {
  SENDING_REQUEST,
  REQUEST_ERROR,
} from '@defi/core-auth';

export function* forgotPassword(username) {
  // We send an action that tells Redux we're sending a request
  yield put({ type: SENDING_REQUEST, sending: true });

  // We then try to log in the user
  try {
    let response = yield call(Auth.forgotPassword, username);
    if (response.Success) {
      yield put({ type: SET_MFA_CHALLENGE, challenge: true });
      return response;
    } else {
      yield put({ type: REQUEST_ERROR, error: [response.Errors] });
      return false;
    }
  } catch (error) {
    yield put({ type: REQUEST_ERROR, error: [error.message] });
    return false;
  } finally {
    yield put({ type: SENDING_REQUEST, sending: false });
  }
}

export function* forgotPasswordFlow() {
  while (true) {
    let request = yield take(REQUEST_FORGOT_PW);
    let username = request.username;
    yield call(forgotPassword, username);
  }
}
